import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { fetchWorkflow } from '../actions';
import { selectWorkflow } from '../selectors';
import { getPrefixBeforeColon } from '../../../utils/string';

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class WithWorkflowComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (!this.props?.workflow) this.props.fetch();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.workflow && this.props.workflow_id !== prevProps.workflow_id) {
      this.props.fetch();
    }
  }

  render() {
    if (!this.props.workflow) return null;

    if (this.props.label) {
      let label = this.props.workflow?.name ?? '';
      if (this.props.shortLabel && label) {
        return <span style={{ whiteSpace: 'normal' }}>{label}</span>;
      }
      if (this.props.abbreviation && label) {
        return <span>{`${getPrefixBeforeColon(label)}`}</span>;
      }
      return <span>{`${label}`}</span>;
    }

    return this.props?.children;
  }
}

WithWorkflowComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workflow: selectWorkflow(ownProps.workflow_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      if (!parseInt(ownProps?.workflow_id, 10)) return;

      dispatch(fetchWorkflow(ownProps?.workflow_id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WithWorkflow = compose(withConnect, withRouter)(WithWorkflowComp);
